import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles, withTheme } from "@material-ui/core/styles";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { GetMenusComponent, Menu } from "../../graphql/components";
import { playTransitionAction } from "../../redux/actions/uiActions";
import { posicionaMinhasOperadorasAntesDaAjuda, promoveMinhasOperadoras } from "./menuMinhasOperadoras";
import styles from "./sidebar-jss";
import SidebarCategory from "./SidebarCategory";
import SidebarLink from "./SidebarLink";

interface Props {
  classes: any;
  loadTransition?: (isLoaded: boolean) => void;
  dataMenu?: Array<any>;
}

// O backend ainda entrega a Central de Alertas com page "menu" e o icone do cadastro
// (MENU.ICONE). Ate o cadastro ser ajustado, o front remapeia a rota e o icone: a rota
// /app/home passou a ser a tela nova (Home).
const LINK_CENTRAL_ALERTAS = "central-alertas";
const LINK_CENTRAL_INTEGRACAO = "central-integracao";
const ICONE_CENTRAL_ALERTAS = "fa fa-bell";

class MainMenu extends React.Component<Props> {
  handleClick() {
    const { loadTransition } = this.props;
    loadTransition!(false);
  }

  getSubMenus = (menus: Array<Menu>, menu: Menu) => {
    const netos = menus.filter((son) => son.pai === menu.label);
    const pai = menus.find((son) => son.label === menu.pai);
    let inset = false;
    let avo = false;
    if (pai) {
      avo = menus.find((son) => son.label === pai.pai) != null;
      inset = avo ? true : false;
    }
    if (netos && netos.length > 0) {
      return (
        <SidebarCategory
          //inset={inset || pai != null}
          key={menu.id}
          title={menu.label!}
          icon={menu.icon!}
          isClickable={menu.page == null || menu.page === ""}
        >
          {netos.map((me) => this.getSubMenus(menus, me))};
        </SidebarCategory>
      );
    } else {
      return <SidebarLink inset={inset || pai != null} key={menu.id} title={menu.label!} link={menu.page!} isNeto={avo} />;
    }
  };

  render() {
    return (
      <GetMenusComponent>
        {({ data, loading, error }) => {
          if (loading) {
            return (
              <div style={{ textAlign: "center" }}>
                <CircularProgress />
              </div>
            );
          }
          if (error) {
            return null;
          }
          if (data && data.getMenus) {
            const menus = promoveMinhasOperadoras(data.getMenus);
            const itensDoBackend = posicionaMinhasOperadorasAntesDaAjuda(menus.filter((menu) => menu.pai == null))
              .map((menu) => {
                if (menu.label === "Relatórios") {
                  menu.page = "relatorios";
                  return (
                    <React.Fragment key={menu.id}>
                      <SidebarLink inset={false} title={menu.label} link={menu.page} icon={menu.icon} />
                    </React.Fragment>
                  );
                } else if (menu.label === "Integração") {
                  menu.page = LINK_CENTRAL_INTEGRACAO;
                  return <SidebarLink inset={false} key={menu.id!} title={menu.label!} link={menu.page!} icon={menu.icon!} />;
                } else if (menu.page) {
                  const link = menu.page === "menu" ? LINK_CENTRAL_ALERTAS : menu.page!;
                  return (
                    <SidebarLink
                      inset={false}
                      key={menu.id!}
                      title={menu.label!}
                      link={link}
                      icon={link === LINK_CENTRAL_ALERTAS ? ICONE_CENTRAL_ALERTAS : menu.icon!}
                    />
                  );
                }
                return (
                  <SidebarCategory
                    key={menu.id!}
                    title={menu.label!}
                    icon={menu.icon!}
                    isClickable={menu.page == null || menu.page === ""}
                  >
                    {menus
                      .filter((filho) => filho.pai === menu.label)
                      .map((filho) => this.getSubMenus(menus, filho))}
                  </SidebarCategory>
                );
              });
            return (
              <React.Fragment>
                {/* Tela nova em desenvolvimento. Entrada TEMPORARIA no front: o menu definitivo
                    vem do backend (Menu.java + recurso de permissao). Remover daqui quando a
                    tela entrar no menu oficial. */}
                <SidebarLink inset={false} title="Home" link="home" icon="fa fa-home" />
                {itensDoBackend}
              </React.Fragment>
            ) as any;
          }
          return null;
        }}
      </GetMenusComponent>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  loadTransition: bindActionCreators(playTransitionAction, dispatch),
});

const MainMenuMapped = connect(
  null,
  mapDispatchToProps
)(MainMenu);

export default withTheme(withStyles(styles as any)(MainMenuMapped));
